angular.module('gym.payers', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.ezidebit_payers', {
    url: '/ezidebit_payers',
    controller: 'EzidebitImportCtrl',
    template: require('templates/gyms/payers/ezidebit_payers.html.slim')
  }).state('gym.stripe_payers', {
    url: '/stripe_payers',
    template: require('templates/gyms/payers/stripe_payers.html.slim')
  });
}]);
